import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { t } from 'i18next';
import { connect } from 'react-redux';
import {
  reduxForm, Field, change, getFormValues,
} from 'redux-form';
import Modal from 'react-modal';
import { endpoints } from '../../utils/constants';
import RenderField from '../ReactComponent/RenderField';
import SortableTable from '../ReactComponent/SortableTable';
import SideBar from '../ReactComponent/SideBar';
import Filter from '../../assets/icons/Filter.svg';
import FilterOrange from '../../assets/icons/FilterOrange.svg';
import { isRequired, dateRangeValidate } from '../../utils/validator';
import Grid from '../../assets/icons/CustomizeGrid.svg';
import Dropdown from './Dropdown';
import ModalContent from './ModalContent';
import RenderHeader from './RenderHeader';
import {
  FilterContainer,
  FilterIcon,
  Icon,
  CategoryTabs,
  Category,
  CategoryTitle,
  PageTitle,
  Close,
  ModalBody,
  CheckBoxField,
  ResetFiltersButton,
  CommonButtonGroup,
  DateFields,
  NoInitialStatus,
} from './css';
import DatePicker from '../../lib/ui/form_elements/DatePicker';
import { putReduxAllShipments, putReduxAllShipmentsHistory, putReduxAllDrafts } from './actions';
import SearchWithFilter from '../ReactComponent/SearchWithFilter';
import CustomizeTableView from '../ReactComponent/CustomizeTableView';
import {
  formatDate,
  downloadFile,
  formatDisplayDate,
  formatMoney,
  runningOnBrowser,
  getSitecoreStateAuthToken,
} from '../../utils/func';
import { apiGetShipments, getShipmentDrafts, apiGetShipmentReports } from '../../services/shipments';
import NoDataDecorator from '../ReactComponent/SortableTable/NoDataDecorator';
import { ShipmentStatuses, Divisions } from '../../utils/enums';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import { getDeliveryDate } from '../../utils/dateTime';
import CommonPrimaryButton, { styleTypes } from '../ReactComponent/PrimaryButton';

import {
  defaultDraftColumns, defaultShipmentColumns, columns, FORM_FIELDS, SHIPMENT_REPORT_DATE_RANGE,
} from './utils';

import { getUser as getUserService } from '../../services/accountService';

const formName = 'ManageShipments';

const tabFilters = {
  default: () => true,
  1: ({ status }) => ![ShipmentStatuses.Delivered, ShipmentStatuses.NotYetPickedUp].includes(status),
  2: ({ status }) => status === ShipmentStatuses.Delivered,
};
const NUMBER_OF_DAYS = 60;
const initialValues = {
  filterFromDate: formatDate(new Date((new Date()).getTime() - (NUMBER_OF_DAYS * 24 * 60 * 60 * 1000))), filterToDate: formatDate(new Date()),
};

class ManageShipments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      filterOpen: false,
      customizeOpen: false,
      // eslint-disable-next-line react/no-unused-state
      dataPerPage: 10,
      activeTab: 4,
      // eslint-disable-next-line react/no-unused-state
      statusList: [],
      initialStatusList: [],
      prevFromDate: initialValues.filterFromDate,
      prevToDate: initialValues.filterToDate,
      columns: defaultShipmentColumns,
      prevAccountNumbers: this.props.accountNumbers,
      accountNumbers: this.props.accountNumbers,
      displayCustomizeTableView: false,
      modalAction: null,
      modalIsOpen: false,
      modalShipmentNumber: null,
      statusFilter: () => true,
      searchValue: '',
      draftsVisited: false,
      historyVisited: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    let { division } = this.props;
    let divisionCode;
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      division = urlParams.get('division');
      switch (division) {
        case Divisions.Freight.name: divisionCode = Divisions.Freight.code; break;
        case Divisions.Sameday.name: divisionCode = Divisions.Sameday.code; break;
        default: divisionCode = Divisions.Truckmate.code; break;
      }
    }

    let { accountNumbers } = this.props;
    getUserService(this.props.userId, divisionCode, getSitecoreStateAuthToken()).then((response) => {
      if (response.data && response.data.billingAccounts && response.data.billingAccounts.length > 0) {
        accountNumbers = [];
        for (let i = 0; i < response.data.billingAccounts.length; i++) {
          accountNumbers.push(response.data.billingAccounts[i].accountNumber);
        }
      }

      this.setState({
        accountNumbers,
        prevAccountNumbers: accountNumbers,
        division,
      }, () => {
        const { dispatch } = this.props;
        dispatch(change('ManageShipments', FORM_FIELDS.FILTER_ACCT_NUMBERS, this.state.accountNumbers));
        setTimeout(() => { this.fetchAllShipments(true); }, 200);
      });
    });
  }

  getInitialStatusList = () => {
    const { allShipments, allShipmentsHistory, dispatch } = this.props;
    const { activeTab } = this.state;
    const uniqueStatus = (activeTab === 4 ? allShipmentsHistory : allShipments)
      .map((s) => s.status).filter((value, index, self) => (self.indexOf(value) === index));
    // eslint-disable-next-line react/no-unused-state
    this.setState({ statusList: uniqueStatus, initialStatusList: uniqueStatus });
    dispatch(change('ManageShipments', 'filterShipmentStatus', uniqueStatus));
  };

  getStatusList = () => {
    const { allShipments, allShipmentsHistory, dispatch } = this.props;
    const { activeTab } = this.props;
    const uniqueStatus = (activeTab === 4 ? allShipmentsHistory : allShipments)
      .map((s) => s.status).filter((value, index, self) => (self.indexOf(value) === index));
    // eslint-disable-next-line react/no-unused-state
    this.setState({ statusList: uniqueStatus });
    dispatch(change('ManageShipments', 'filterShipmentStatus', uniqueStatus));
  };

  handleDownloadReport = () => {
    this.setState({ modalIsOpen: true, modalAction: 'download' });
  };

  handleSubmitFilter = () => {
    const { formData: { filterFromDate, filterToDate, filterAccountNumbers }, dispatch } = this.props;
    const {
      activeTab, prevFromDate, prevToDate, prevAccountNumbers,
    } = this.state;
    if (activeTab === 3 || filterFromDate !== prevFromDate || filterToDate !== prevToDate || filterAccountNumbers !== prevAccountNumbers) {
      this.fetchAllShipments(false, filterFromDate, filterToDate, filterAccountNumbers);
    } else {
      this.applyFrontFilters();
    }

    dispatch(change(formName, 'searchByKey', '')); // Clear the search field, on submit (ECE-1643)...
    this.toggleFilter();
  };

  handleDownloadSubmit = async () => {
    if (!this.props.valid) return;

    const { formData: { filterFromDate, filterToDate, filterAccountNumbers } } = this.props;

    const accountNumbers = filterAccountNumbers.filter((n) => n !== '');
    if (!accountNumbers || accountNumbers.length === 0) return;
    await apiGetShipmentReports(this.state.division, accountNumbers, filterFromDate, filterToDate).then((res) => {
      if (res.status === 200) {
        const { fileName, mimeType, fileDataAsBase64 } = res.data;
        const fileType = fileName.includes('.csv') ? '' : '.csv';
        downloadFile({ dataAsBase64: fileDataAsBase64, mimeType, filename: fileName + fileType });
      }
    });
  };

  toggleCustomizeTableView = () => {
    if (runningOnBrowser()) {
      window.scrollTo(0, 0);
    }

    this.setState((prevState) => ({ displayCustomizeTableView: !prevState.displayCustomizeTableView }));
  };

  toggleFilter = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }

    const { filterOpen } = this.state;
    this.setState({ filterOpen: !filterOpen });
  };

  updateTable = (newColumns) => {
    this.setState({ columns: newColumns });
  };

  fetchAllShipments = async (init, filterFrom, filterTo, filterAccountNumbers) => {
    const { userId } = this.props;
    const { activeTab, accountNumbers } = this.state;
    if (activeTab === 3) {
      getShipmentDrafts(this.state.division, userId, 30).then((res) => {
        if (res.status === 200) {
          const { putReduxAllDrafts } = this.props;
          const isDraft = true;
          const convertedData = this.convertDataFormat(res.data, isDraft);
          putReduxAllDrafts(convertedData);
          this.setState({ data: convertedData });
        }
      });
    } else {
      apiGetShipments(this.state.division,
        filterAccountNumbers || accountNumbers,
        filterFrom || initialValues.filterFromDate,
        filterTo || initialValues.filterToDate,
        activeTab === 4)// active tab === history tab
        .then((res) => {
          if (res.status === 200) {
            const { putReduxAllShipments, putReduxAllShipmentsHistory } = this.props;
            const convertedData = this.convertDataFormat(res.data);
            if (activeTab === 4) {
              putReduxAllShipmentsHistory(convertedData);
            } else {
              putReduxAllShipments(convertedData);
            }

            this.setState({ data: convertedData });
            if (!init) {
              this.applyFrontFilters();
              this.filterList();
              this.getStatusList();
            } else {
              this.getInitialStatusList();
            }
          }
        });
    }

    this.setState({ prevFromDate: filterFrom || initialValues.filterFromDate });
    this.setState({ prevToDate: filterTo || initialValues.filterToDate });
    this.setState({ prevAccountNumbers: filterAccountNumbers || accountNumbers });
  };

  openBOL = (probillNumber) => {
    const { emailAddress, userId } = this.props;
    axios.get(
      `${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${endpoints.shipping.shipmentDocuments}/${this.state.division}/${probillNumber}/bol`,
      {
        params: {
          emailAddress,
          userId,
        },
      }).then((res) => {
      if (res.status === 200) {
        downloadFile({ dataAsBase64: res.data.fileDataAsBase64, mimeType: res.data.mimeType, filename: res.data.fileName });
      }
    });
  };

  convertDataFormat = (data, draftActions) => data.map((each) => ({
    probillNumber: each.probillNumber,
    shipmentId: each.shipmentId,
    deliveryDate: each.deliveryDate && getDeliveryDate({ deliveryDate: each.deliveryDate, deliveryDateType: each.deliveryDateType }),
    createDate: each.createDate && formatDisplayDate(each.createDate),
    from: `${[each.from.name, each.from.city, each.from.provinceCode, each.from.countryCode].filter(Boolean).join(', ')}`,
    to: `${[each.to.name, each.to.city, each.to.provinceCode, each.to.countryCode].filter(Boolean).join(', ')}`,
    bol: each.bolNumber,
    shipmentDate: each.shipDate && formatDisplayDate(each.shipDate),
    deliveryOrigin: each.originTerminal,
    deliveryDestination: each.destinationTerminal,
    palletsInDelivery: each.pallets,
    piecesInDelivery: each.pieces,
    weightOfDelivery: each.weight.value,
    charge: each.charge ? formatMoney(each.charge.value) : null,
    status: each.status,
    actions: <Dropdown
      draftActions={draftActions}
      status={each.status}
      openBOL={() => this.openBOL(each.probillNumber)}
      probillNumber={each.probillNumber}
      shipmentId={each.shipmentId}
      shipmentNumber={each.shipmentNumber}
      division={this.state.division}
      cancelShipment={() => this.cancelShipment(each.probillNumber)}
      shareShipment={() => this.shareShipment(each.probillNumber)}
    />,
  }));

  getSuggestions = (value) => {
    const searchValue = value.toLowerCase().trim();
    this.setState({ searchValue }, this.filterList);
  };

  filterRowByValue = (value) =>
    (row) => columns.some(
      ({ field }) => typeof row[field] === 'string' && row[field].toLowerCase().indexOf(value) !== -1,
    );

  changeTab = (tabIndex) => {
    const statusFilter = tabFilters[tabIndex] ? tabFilters[tabIndex] : tabFilters.default;
    if (tabIndex === 3) {
      this.setState({ columns: defaultDraftColumns }, () => {
        if (!this.state.draftsVisited) {
          this.fetchAllShipments();
        }

        this.setState({ draftsVisited: true });
      });
    } else if (tabIndex === 4) {
      this.setState({ columns: defaultShipmentColumns }, () => {
        if (!this.state.historyVisited) {
          this.fetchAllShipments();
        }

        this.setState({ historyVisited: true });
      });
    }

    this.setState({ statusFilter, activeTab: tabIndex, columns: defaultShipmentColumns }, this.filterList);
  };

  filterList = () => {
    const { statusFilter, searchValue, activeTab } = this.state;
    const { allShipments, allDrafts, allShipmentsHistory } = this.props;
    const filterBySearchInput = this.filterRowByValue(searchValue);
    let data = allShipments;
    if (activeTab === 4) {
      data = allShipmentsHistory;
    } else if (activeTab === 3) {
      data = allDrafts;
    }

    const filteredData = data
      .filter(statusFilter)
      .filter(filterBySearchInput);
    this.setState({ data: filteredData });
  };

  applyFrontFilters = () => {
    const {
      dispatch, allShipments, allShipmentsHistory, formData: { filterShipmentStatus },
    } = this.props;
    const { activeTab } = this.state;
    dispatch(change(formName, 'searchByKey', ''));
    let filteredData = [];
    if (filterShipmentStatus) {
      filterShipmentStatus.forEach((status) => {
        filteredData = filteredData.concat(
          (activeTab === 4 ? allShipmentsHistory : allShipments)
            .filter((s) => s.status === status),
        );
        filteredData = filteredData.filter((value, index, self) => (self.indexOf(value) === index));
      });
    }

    this.setState({ data: filteredData });
  };

  resetFilters = () => {
    const { dispatch } = this.props;
    dispatch(change('ManageShipments', 'filterShipmentStatus', this.state.initialStatusList));
    dispatch(change('ManageShipments', 'filterFromDate', initialValues.filterFromDate));
    dispatch(change('ManageShipments', 'filterToDate', initialValues.filterToDate));
    dispatch(change('ManageShipments', FORM_FIELDS.FILTER_ACCT_NUMBERS, this.state.accountNumbers));
    dispatch(change(formName, 'searchByKey', '')); // Clear the search field, on reset (ECE-1643)...

    this.fetchAllShipments(false, initialValues.filterFromDate, initialValues.filterToDate, this.state.accountNumbers);
  };

  postShare() {
    if (this.props.valid) {
      this.closeModal();
    }
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    this.setState({ modalShipmentNumber: null });
    this.setState({ modalAction: null });
  }

  openModal(shipmentNumber, modalAction) {
    this.setState({ modalAction });
    this.setState({ modalIsOpen: true });
    this.setState({ modalShipmentNumber: shipmentNumber });
  }

  shareShipment(shipmentNumber) {
    this.openModal(shipmentNumber, 'share');
  }

  cancelShipment(shipmentNumber) {
    this.openModal(shipmentNumber, 'cancel');
  }

  render() {
    const {
      rendering: { fields: { heading, description } }, valid, formData,
    } = this.props;
    const {
      filterOpen, customizeOpen, activeTab, data, initialStatusList, modalShipmentNumber, modalAction, modalIsOpen, accountNumbers,
    } = this.state;
    return (
      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <Close onClick={this.closeModal} />
          <ModalBody className="justify-content-center">
            <ModalContent
              closeModal={this.closeModal}
              modalAction={modalAction}
              modalShipmentNumber={modalShipmentNumber}
              handleDownloadSubmit={this.handleDownloadSubmit}
              accountNumbers={accountNumbers}
              postShare={(e) => {
                e.preventDefault();
                this.postShare();
              }}
              valid={valid}
            />
          </ModalBody>
        </Modal>
        {
          filterOpen && (
          <SideBar close={this.toggleFilter}>
            <form>
              <PageTitle>{t('ApplyFilters')}</PageTitle>
              {
                initialStatusList.length === 0 && (
                  <>
                    <CategoryTitle>{t('FilterByShipmentStatus')}</CategoryTitle>
                    <NoInitialStatus>
                      {t('NoShipmentStatus')}
                    </NoInitialStatus>
                  </>
                )
              }
              {
                initialStatusList.length > 0 && (
                  <>
                    <CategoryTitle>{t('FilterByShipmentStatus')}</CategoryTitle>
                    <CheckBoxField
                      name="filterShipmentStatus"
                      type="checkboxes"
                      component={RenderField}
                      multiple
                      data={initialStatusList}
                    />
                  </>
                )
              }
              <CategoryTitle>{t('FilterByDateCreated')}</CategoryTitle>
              <DateFields>
                <Field
                  name="filterFromDate"
                  type="date"
                  component={DatePicker}
                  className="date-container"
                  initialDate={SHIPMENT_REPORT_DATE_RANGE.MIN}
                  maxDate={SHIPMENT_REPORT_DATE_RANGE.MAX}
                  label={t('Date')}
                  validate={[
                    isRequired,
                    dateRangeValidate,
                  ]}
                />
                <Field
                  name="filterToDate"
                  type="date"
                  component={DatePicker}
                  className="date-container"
                  label={t('Date')}
                  initialDate={SHIPMENT_REPORT_DATE_RANGE.MIN}
                  maxDate={SHIPMENT_REPORT_DATE_RANGE.MAX}
                  validate={[
                    isRequired,
                    dateRangeValidate,
                  ]}
                />
              </DateFields>
              <CategoryTitle>{t('FilterByBillingAccount')}</CategoryTitle>
              <Field
                name={FORM_FIELDS.FILTER_ACCT_NUMBERS}
                type="checkboxes"
                component={RenderField}
                multiple
                data={accountNumbers}
              />
              <CommonButtonGroup>
                <ResetFiltersButton
                  type="button"
                  styleType={styleTypes.SECONDARY}
                  onClick={() => this.resetFilters()}
                >
                  <span className="icon" />
                  {t('ResetFilters')}
                </ResetFiltersButton>
                <CommonPrimaryButton
                  type="button"
                  onClick={() => this.handleSubmitFilter()}
                  disabled={
                    !valid
                    || (formData && formData[FORM_FIELDS.FILTER_ACCT_NUMBERS] && formData[FORM_FIELDS.FILTER_ACCT_NUMBERS].length <= 0)
                  }
                >
                  <span className="icon" />
                  {t('ApplyFilters')}
                </CommonPrimaryButton>
              </CommonButtonGroup>
            </form>
          </SideBar>
          )
          }
        {RenderHeader({ heading: heading.value, description: description.value, handleDownloadReport: this.handleDownloadReport })}

        <FilterContainer>
          <CategoryTabs className="row">
            {/* <Category className={`col ${activeTab === 0 && 'active'}`} onClick={() => this.changeTab(0)}>{t('RecentShipments')}</Category> */}
            <Category className={`col ${activeTab === 4 && 'active'}`} onClick={() => this.changeTab(4)}>{t('ByAccountNum')}</Category>
          </CategoryTabs>
          <div className="row justify-content-md-center">
            <div className="col-md-9">
              <div className="col p-0 filters-container">
                <SearchWithFilter label={t('SearchShipmentText')} getSuggestions={this.getSuggestions} />
                {activeTab !== 3
                  && (
                  <div className="row justify-content-between">
                    <FilterIcon className="col-md-3" onClick={this.toggleFilter}>
                      <Icon src={filterOpen ? Filter : FilterOrange} alt="Filter" />
                      {t('ApplyFilters')}
                    </FilterIcon>
                    <FilterIcon className="col-md-3 text-right" onClick={this.toggleCustomizeTableView}>
                      <Icon src={Grid} alt="Customize" className={customizeOpen ? 'active' : ''} />
                      {t('CustomizeView')}
                    </FilterIcon>
                  </div>
                  )}
              </div>
            </div>
          </div>
        </FilterContainer>

        <NoDataDecorator component={SortableTable} data={data} columns={this.state.columns} />

        {
          this.state.displayCustomizeTableView && (
            <CustomizeTableView
              columns={columns}
              updateTable={this.updateTable}
              hideView={this.toggleCustomizeTableView}
            />
          )
        }
      </div>
    );
  }
}

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  division: state.division,
  accountNumbers: state.profile.accountNumbers,
  userId: state.profile.userId,
  allShipments: state.user.allShipments,
  allDrafts: state.user.allDrafts,
  allShipmentsHistory: state.user.allShipmentsHistory,
  emailAddress: state.profile.email,
});

const mdtp = (dispatch) => ({
  putReduxAllShipments: (allShipments) => dispatch(putReduxAllShipments(allShipments)),
  putReduxAllShipmentsHistory: (allShipmentsHistory) => dispatch(putReduxAllShipmentsHistory(allShipmentsHistory)),
  putReduxAllDrafts: (allDrafts) => dispatch(putReduxAllDrafts(allDrafts)),
});

ManageShipments = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
})(ManageShipments);

export default connect(mstp, mdtp)(ManageShipments);

ManageShipments.propTypes = {
  dispatch: PropTypes.func,
  division: PropTypes.string,
  userId: PropTypes.string,
  accountNumbers: PropTypes.arrayOf(PropTypes.string),
  allShipments: PropTypes.array,
  allDrafts: PropTypes.array,
  allShipmentsHistory: PropTypes.array,
  emailAddress: PropTypes.string,
  putReduxAllShipments: PropTypes.func,
  putReduxAllShipmentsHistory: PropTypes.func,
  putReduxAllDrafts: PropTypes.func,
  formData: PropTypes.shape({
    filterFromDate: PropTypes.string,
    filterToDate: PropTypes.string,
    filterAccountNumbers: PropTypes.arrayOf(PropTypes.string),
    filterShipmentStatus: PropTypes.arrayOf(PropTypes.string),
  }),
  valid: PropTypes.bool,
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      heading: PropTypes.shape({
        value: PropTypes.string,
      }),
      description: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  }),
  activeTab: PropTypes.number,
};

